import type { TFunction } from 'i18next';
import { z } from 'zod';

/** Schéma de création d'une marque produit pour une boutique custom. */
export function buildCustomShopBrandFormSchema(t: TFunction) {
  return z.object({
    name: z
      .string()
      .trim()
      .min(1, t('admin.shops.brands.form.name.required'))
      .max(255, t('admin.shops.brands.form.name.max'))
  });
}

export type CustomShopBrandFormValues = z.infer<ReturnType<typeof buildCustomShopBrandFormSchema>>;
